module.exports = __webpack_public_path__ + "static/media/cryro2.5411ee8c.png";